module.exports = require("./ee-TG.js");